import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from "react-helmet";
// eslint-disable-next-line import/no-unresolved
import { useLocation } from "@reach/router";
import { addWWW } from "@/base/utils/addWWW";
interface SeoProps {
  data: StoryblokMetaData;
  ogType: TemplateType;
}

interface SeoMetaData {
  site: {
    siteMetadata: {
      name: string;
      title: string;
      description: string;
      ogImage: string;
      twitterUsername: string;
    };
  };
}

export function Seo({ data, ogType }: SeoProps) {
  const { pathname } = useLocation();
  const { site } = useStaticQuery<SeoMetaData>(
    graphql`
      query {
        site {
          siteMetadata {
            name
            title
            description
            ogImage
            twitterUsername
          }
        }
      }
    `
  );
  const { name, title, description, ogImage, twitterUsername } =
    site.siteMetadata;

  const seo = {
    title: data?.title || title,
    description: data?.description || description,
    image: data?.og_image || ogImage,
    url: new URL(pathname, process.env.GATSBY_URL),
  };

  const seoTitleProps = {
    ...(pathname === "/"
      ? { title: "", titleTemplate: "" }
      : {
          title: seo.title,
          titleTemplate: `%s | ${name}`,
        }),
  };

  const forwardSlash = !pathname.endsWith("/") ? "/" : "";
  const addForwardSlashSuffix = seo.url.toString() + forwardSlash;

  return (
    <Helmet
      {...seoTitleProps}
      htmlAttributes={{
        lang: "en-US",
      }}
    >
      <link rel="canonical" href={addWWW(addForwardSlashSuffix)} />
      <meta
        name="google-site-verification"
        content={process.env.GATSBY_GOOGLE_SITE_VERIFICATION_TOKEN}
      />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      <meta property="og:url" content={seo.url.toString()} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <link rel="preconnect" href="https://a.storyblok.com" />
      <link rel="preconnect" href="https://img2.storyblok.com" />
      <link rel="dns-prefetch" href="https://a.storyblok.com" />
      <link rel="dns-prefetch" href="https://img2.storyblok.com" />
    </Helmet>
  );
}
